const MAX_BATCH_SIZE = 10;
const BATCH_DELAY = 200;
function createDispatcher(_ref) {
  let {
    debug,
    tracking_url
  } = _ref;
  let event_queue = [];
  let batch_timeout;
  const send = () => {
    if (!event_queue.length || typeof window === 'undefined') {
      return;
    }
    const data = JSON.stringify(event_queue);
    const cet_event = document.createEvent('CustomEvent');
    cet_event.initCustomEvent('cet-event', false, false, event_queue);
    dispatchEvent(cet_event);
    if (debug) {
      window.fetch(`${tracking_url}/events`, {
        method: 'POST',
        body: data,
        keepalive: true
      }).then(response => response.json()).then(response => {
        if (response.errors && response.debug) {
          console.group('%c 🚨 Rejected client events 🚨', 'background-color: #250201; color: #ee8783; border: 1px solid #540b06');
          response.debug.forEach(d => console.table(d.validation));
          console.groupEnd();
        }
      }).catch(() => {
        const data_obj = JSON.parse(data);
        console.group(`%cClient Event Tracking: %crun nsq_api_public to verify events`, 'font-weight: bold;', 'color: gray; font-size: .5rem;');
        data_obj.forEach(event => {
          console.groupCollapsed(`"%c${event.type}"`, 'font-weight: bold; font-family: monospace;');
          console.table(event);
          console.groupEnd();
        });
        console.groupEnd();
      });
    } else {
      let sent;
      if (navigator && navigator.sendBeacon) {
        sent = navigator.sendBeacon(`${tracking_url}/events`, data);
      } else {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${tracking_url}/events`, false);
        xhr.onerror = () => {};
        xhr.setRequestHeader('Accept', '*/*');
        xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
        sent = xhr.send(data);
      }
      // Sampling this specific error as it's happening with high frequency
      // in Safari 13.0.x
      if (!sent && window.raven && Math.random() < 0.1) {
        window.raven.captureException('Client Event Tracking: sendBeacon could not process a queue.');
      }
    }
    clearTimeout(batch_timeout);
    batch_timeout = null;
    event_queue = [];
  };
  const push = data => {
    event_queue.push(data);
    if (event_queue.length === MAX_BATCH_SIZE) {
      send();
    }
    if (!batch_timeout) {
      batch_timeout = setTimeout(send, BATCH_DELAY);
    }
  };
  return [push, send];
}

export { createDispatcher };
